import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import type { Order } from '../types/order.type';

export const GetOrderSchema = z.object({
  order_id: z.string().min(1, {
    message: 'id order tidak boleh kosong!',
  }),
});
export type GetOrderPayload = z.infer<typeof GetOrderSchema>;
export type GetOrderResponse = ApiResponse<Order>;

export const getOrder = async (
  payload: GetOrderPayload
): Promise<GetOrderResponse> => {
  const { order_id } = payload;
  const url = `order/${order_id}`;

  return await apiClient.get(url);
};

export const GET_ORDER_QUERY_KEY = 'order';
export function getOrderQueryOptions(payload: GetOrderPayload) {
  return queryOptions({
    queryKey: [GET_ORDER_QUERY_KEY, payload.order_id],
    queryFn: () => getOrder(payload),
  });
}
